import type { DocPageContent } from '../docs-content'

const page = {
  order: 19,
  slug: 'render-queue',
  title: 'Cola de Renderizado',
  description:
    'Encola múltiples exportaciones, divide un renderizado en segmentos, gestiona la cola y localiza los archivos guardados.',
  category: 'Salida',
  related: ['export'],
  sections: [
    {
      title: 'Encolar exportaciones',
      blocks: [
        {
          kind: 'list',
          items: [
            'Desde el diálogo de Exportación, elige **Añadir a la cola** en lugar de renderizar inmediatamente.',
            'Encola todo el proyecto o el rango actual.',
            'Abre la cola en cualquier momento desde el botón **Cola de renderizado** en la barra de herramientas, que muestra un contador de trabajos en vivo.',
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: 'Las exportaciones encoladas se renderizan una a la vez y se guardan en la carpeta de exportaciones de tu espacio de trabajo.',
        },
      ],
    },
    {
      title: 'Dividir en segmentos',
      blocks: [
        {
          kind: 'list',
          items: [
            '**Dividir en segmentos** convierte un renderizado en varios trabajos.',
            'Usa **Un segmento por marcador** para dividir el renderizado en tus marcadores de la línea de tiempo.',
            'O divide en fragmentos fijos de un número determinado de segundos.',
          ],
        },
      ],
    },
    {
      title: 'Gestionar la cola',
      blocks: [
        {
          kind: 'list',
          items: [
            '**Pausar** y **Reanudar** la cola para controlar cuándo ocurre el renderizado.',
            'Mueve un trabajo encolado **Arriba** o **Abajo** para cambiar su orden.',
            '**Cancelar** un trabajo en ejecución o encolado, **Reintentar** uno fallido y **Eliminar** trabajos finalizados.',
            'El estado del trabajo se lee como Encolado, Renderizando, Hecho, Fallido o Cancelado; usa **Limpiar finalizados** o **Limpiar todo** para ordenar.',
          ],
        },
      ],
    },
    {
      title: 'Exportaciones guardadas',
      blocks: [
        {
          kind: 'list',
          items: [
            'Cambia a la pestaña **Exportaciones guardadas** para ver los archivos completados.',
            'Descarga o Elimina una exportación guardada desde allí.',
            'Los archivos residen en esta carpeta del proyecto dentro de tu espacio de trabajo.',
          ],
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page